module.exports = __webpack_public_path__ + "static/media/54.43625236.png";